// switch to 'uat' or 'prod'
export const environment = getEnv('uat');

function getEnv(env) {
  if (env === 'dev') {
    return {
      supplierId: '7',
      analyticsKey: '-',
      apiHost: 'http://localhost:3000'
    };
  } else if (env === 'uat') {
    return {
      supplierId: '3',
      analyticsKey: '-',
      apiHost: 'https://api-uat.miam.tech'
    };
  } else {
    return {
      supplierId: '-', // TODO
      analyticsKey: '-', // TODO
      apiHost: 'https://api.miam.tech'
    };
  }
}
